module.exports = __webpack_public_path__ + "img/mp3.e84c6acd.png";